// https://usehooks.com/useWindowSize/, but with a debounce thrown in
import { useEffect, useState } from "react";
import { debounce } from "lodash";

interface useWindowSizeOptions {
  debounceInterval?: number;
}

export const useWindowSize = ({
  debounceInterval = 0,
}: useWindowSizeOptions) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const onDebounce = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    const onResize = debounce(onDebounce, debounceInterval);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []); // Empty array ensures that effect is only run on mount and unmount
  return windowSize;
};
